<div class="grid layout" *ngIf="newBot">
  <div class="col-12">
    <h1 style="text-align: center; font-weight: 700; font-family: sans-serif">Archivo</h1>
  </div>
  <div class="col-12 md:col-6 lg:col-6 flex flex-column" style="margin-bottom: 34px">
    <p>
      Asegúrate que tu archivo contenga texto principalmente, las imágenes no las tomará en cuenta.
    </p>
  </div>
  <div
    class="upload-container"
    (click)="openFileInput()"
    (drop)="onFileDropped($event)"
    (dragover)="onDragOverArea($event)"
    (dragleave)="onDragLeaveArea($event)"
    [ngClass]="{ 'drag-over': isDragOver }"
    style="user-select: none"
  >
    <input
      type="file"
      #fileInput
      style="display: none"
      (change)="onFileSelected($event)"
      accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt"
    />
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
      <path
        d="M30.44 35.5H5.56001C4.86644 35.4717 4.18525 35.3069 3.55542 35.0151C2.9256 34.7233 2.3595 34.3101 1.88952 33.7992C1.41954 33.2884 1.05491 32.6899 0.816479 32.038C0.578051 31.3861 0.47051 30.6935 0.50001 30V24C0.50001 23.6022 0.658045 23.2206 0.939349 22.9393C1.22065 22.658 1.60218 22.5 2.00001 22.5C2.39783 22.5 2.77937 22.658 3.06067 22.9393C3.34197 23.2206 3.50001 23.6022 3.50001 24V30C3.44837 30.5939 3.62729 31.1848 3.99967 31.6503C4.37205 32.1157 4.9093 32.42 5.50001 32.5H30.44C31.0307 32.42 31.568 32.1157 31.9403 31.6503C32.3127 31.1848 32.4916 30.5939 32.44 30V24C32.44 23.6022 32.598 23.2206 32.8793 22.9393C33.1607 22.658 33.5422 22.5 33.94 22.5C34.3378 22.5 34.7194 22.658 35.0007 22.9393C35.282 23.2206 35.44 23.6022 35.44 24V30C35.4999 31.3907 35.0082 32.7489 34.0718 33.7789C33.1354 34.8089 31.8301 35.4275 30.44 35.5Z"
        fill="#7B5CF5"
      />
      <path
        d="M26.0001 11.5C25.803 11.5009 25.6077 11.4625 25.4257 11.3869C25.2436 11.3114 25.0785 11.2002 24.9401 11.06L18.0001 4.11999L11.0601 11.06C10.7757 11.325 10.3996 11.4692 10.011 11.4623C9.62241 11.4555 9.25164 11.2981 8.97682 11.0232C8.70199 10.7484 8.54457 10.3776 8.53771 9.98904C8.53085 9.60043 8.6751 9.22434 8.94006 8.93999L16.9401 0.939992C17.2213 0.659091 17.6026 0.501312 18.0001 0.501312C18.3976 0.501312 18.7788 0.659091 19.0601 0.939992L27.0601 8.93999C27.341 9.22124 27.4987 9.60249 27.4987 9.99999C27.4987 10.3975 27.341 10.7787 27.0601 11.06C26.9216 11.2002 26.7565 11.3114 26.5744 11.3869C26.3924 11.4625 26.1971 11.5009 26.0001 11.5Z"
        fill="#7B5CF5"
      />
      <path
        d="M18 25.5C17.6038 25.4948 17.2253 25.3351 16.9451 25.0549C16.6649 24.7747 16.5052 24.3962 16.5 24V2C16.5 1.60218 16.658 1.22064 16.9393 0.93934C17.2206 0.658035 17.6022 0.5 18 0.5C18.3978 0.5 18.7794 0.658035 19.0607 0.93934C19.342 1.22064 19.5 1.60218 19.5 2V24C19.4948 24.3962 19.3351 24.7747 19.0549 25.0549C18.7747 25.3351 18.3962 25.4948 18 25.5Z"
        fill="#7B5CF5"
      />
    </svg>
    <h4>Haz click para cargar o arrastra y suelta</h4>
    <p style="color: var(--color-primary)">
      1 archivo permitido (PDF, DOC, DOCX, XLS, XLSX, TXT, CSV) 5MB máximo de peso
    </p>
  </div>
  <div
    *ngIf="newBot"
    class="buttonBack"
    [ngStyle]="isMobile ? { width: 'calc(50% - 20px)' } : { width: 'auto' }"
  >
    <globot-button
      [text]="'Volver'"
      [width]="isMobile ? 'w-100' : 'w-auto'"
      [icon]="'pi pi-arrow-left'"
      [iconPosition]="'left'"
      [styleClass]="'secondary'"
      (clickEvent)="back()"
    ></globot-button>
  </div>
</div>

<ng-template [ngIf]="!newBot">
  <div class="layout-modal">
    <div
      class="layout-modal upload-container info"
      (click)="openFileInput()"
      (drop)="onFileDropped($event)"
      (dragover)="onDragOverArea($event)"
      (dragleave)="onDragLeaveArea($event)"
      [ngClass]="{ 'drag-over': isDragOver }"
      style="user-select: none"
    >
      <input
        type="file"
        #fileInput
        style="display: none"
        (change)="onFileSelected($event)"
        accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt"
      />
      <svg
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="upload">
          <path
            id="Vector"
            d="M30.4399 35.5H5.55989C4.86631 35.4717 4.18513 35.3069 3.5553 35.0151C2.92548 34.7233 2.35938 34.3101 1.8894 33.7992C1.41942 33.2884 1.05479 32.6899 0.816357 32.038C0.577929 31.3861 0.470388 30.6935 0.499888 30V24C0.499888 23.6022 0.657923 23.2206 0.939227 22.9393C1.22053 22.658 1.60206 22.5 1.99989 22.5C2.39771 22.5 2.77924 22.658 3.06055 22.9393C3.34185 23.2206 3.49989 23.6022 3.49989 24V30C3.44825 30.5939 3.62717 31.1848 3.99955 31.6503C4.37193 32.1157 4.90918 32.42 5.49989 32.5H30.4399C31.0306 32.42 31.5678 32.1157 31.9402 31.6503C32.3126 31.1848 32.4915 30.5939 32.4399 30V24C32.4399 23.6022 32.5979 23.2206 32.8792 22.9393C33.1605 22.658 33.5421 22.5 33.9399 22.5C34.3377 22.5 34.7192 22.658 35.0005 22.9393C35.2818 23.2206 35.4399 23.6022 35.4399 24V30C35.4998 31.3907 35.008 32.7489 34.0717 33.7789C33.1353 34.8089 31.83 35.4275 30.4399 35.5Z"
            fill="#7B5CF5"
          />
          <path
            id="Vector_2"
            d="M25.9997 11.5C25.8026 11.501 25.6073 11.4625 25.4253 11.387C25.2433 11.3114 25.0782 11.2002 24.9397 11.06L17.9997 4.12002L11.0597 11.06C10.7753 11.325 10.3993 11.4692 10.0106 11.4624C9.62205 11.4555 9.25128 11.2981 8.97645 11.0233C8.70162 10.7484 8.5442 10.3777 8.53734 9.98907C8.53049 9.60046 8.67473 9.22437 8.93969 8.94002L16.9397 0.940023C17.2209 0.659122 17.6022 0.501343 17.9997 0.501343C18.3972 0.501343 18.7784 0.659122 19.0597 0.940023L27.0597 8.94002C27.3406 9.22127 27.4984 9.60252 27.4984 10C27.4984 10.3975 27.3406 10.7788 27.0597 11.06C26.9212 11.2002 26.7561 11.3114 26.5741 11.387C26.3921 11.4625 26.1968 11.501 25.9997 11.5Z"
            fill="#7B5CF5"
          />
          <path
            id="Vector_3"
            d="M18 25.5C17.6038 25.4948 17.2253 25.3351 16.9451 25.0549C16.6649 24.7747 16.5052 24.3962 16.5 24V2C16.5 1.60218 16.658 1.22064 16.9393 0.93934C17.2206 0.658035 17.6022 0.5 18 0.5C18.3978 0.5 18.7794 0.658035 19.0607 0.93934C19.342 1.22064 19.5 1.60218 19.5 2V24C19.4948 24.3962 19.3351 24.7747 19.0549 25.0549C18.7747 25.3351 18.3962 25.4948 18 25.5Z"
            fill="#7B5CF5"
          />
        </g>
      </svg>
      <h4>Haz click para cargar o arrastra y suelta</h4>
      <p style="color: var(--color-primary)">
        1 archivo permitido (PDF, DOC, DOCX, XLS, XLSX, TXT, CSV) 5MB máximo de peso
      </p>
    </div>
    <p *ngIf="fileName">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        style="margin-right: 10px"
      >
        <path
          d="M10.5028 9.78719C10.5028 9.78719 14.0893 9.13694 14.0893 10.3621C14.0893 11.5872 11.8674 11.0888 10.5028 9.78719ZM7.85116 9.88057C7.28134 10.0065 6.72603 10.1908 6.19404 10.4307L6.64404 9.41819C7.09404 8.40569 7.56091 7.02532 7.56091 7.02532C8.09789 7.92907 8.72266 8.77767 9.42616 9.55882C8.89563 9.63793 8.36984 9.74609 7.85116 9.88282V9.88057ZM6.43142 2.56807C6.43142 1.50044 6.77679 1.20907 7.04566 1.20907C7.31454 1.20907 7.61717 1.33844 7.62729 2.26544C7.53969 3.19757 7.34452 4.11643 7.04566 5.00369C6.6363 4.25876 6.42445 3.42143 6.43029 2.57144L6.43142 2.56807ZM1.20129 14.3986C0.101039 13.7404 3.50867 11.7143 4.12629 11.6491C4.12292 11.6502 2.35329 15.0871 1.20129 14.3986ZM15.1367 10.5072C15.1254 10.3947 15.0242 9.14932 12.8079 9.20219C11.8841 9.1873 10.9608 9.25242 10.0483 9.39682C9.16434 8.50627 8.40312 7.50178 7.78479 6.40994C8.17435 5.28429 8.4101 4.11119 8.48567 2.92244C8.45304 1.57244 8.13017 0.798441 7.09517 0.809691C6.06017 0.820941 5.90941 1.72657 6.04554 3.07432C6.17888 3.98 6.4304 4.86428 6.79366 5.70457C6.79366 5.70457 6.31554 7.19294 5.68329 8.67344C5.05104 10.1539 4.61904 10.9302 4.61904 10.9302C3.51961 11.2881 2.48462 11.8198 1.55342 12.5052C0.626415 13.3681 0.24954 14.0307 0.73779 14.6933C1.15854 15.2648 2.63117 15.3942 3.94742 13.6696C4.64678 12.7788 5.28571 11.8422 5.85991 10.8661C5.85991 10.8661 7.86691 10.3159 8.49129 10.1652C9.11566 10.0144 9.87054 9.89519 9.87054 9.89519C9.87054 9.89519 11.7032 11.7391 13.4705 11.6738C15.2379 11.6086 15.1524 10.6174 15.1412 10.5094"
          fill="#DD2025"
        />
      </svg>
      {{ fileName }}
    </p>
    <div *ngIf="hasError">
      <p style="color: red">El archivo seleccionado no tiene una extensión permitida.</p>
    </div>
  </div>
  <div style="margin-top: 100px">
    <div
      style="position: absolute; bottom: 10px; left: 10px"
      [ngStyle]="isMobile ? { width: 'calc(50% - 20px)' } : { width: 'auto' }"
    >
      <globot-button
        [text]="'Volver'"
        [width]="isMobile ? 'w-100' : 'w-auto'"
        [icon]="'pi pi-arrow-left'"
        [iconPosition]="'left'"
        [styleClass]="'secondary'"
        (clickEvent)="back()"
      ></globot-button>
    </div>
  </div>
</ng-template>
